import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import $ from "jquery";
import "datatables.net-bs4";
import { UserContext } from "../../App";
import { deleteUsers, useUsers } from "../../utils/users";
import moment from "moment-timezone";
import ActionsMenu from "../layout/ActionsMenu";
import { StyledTr } from "./bookingContent";
import TrashIcon from "../icons/TrashIcon";
import SelectionActionsPopup from "../layout/SelectionActionsPopup";
import { OutlineButtonLink } from "../layout/OutlineButton";

export default function UserContent() {
  const { userInfos } = useContext(UserContext);

  const { users, loaded } = useUsers();
  const [checked, setChecked] = useState([]);
  const datatable = useRef(null);

  useEffect(() => {
    if (datatable.current) {
      datatable.current.destroy();
      datatable.current = null;
    }

    window.setTimeout(() => {
      datatable.current = $("#datatable").DataTable({
        retrieve: true,
        order: [[1, "asc"]],
        pageLength: 25,
      });
    }, 1);
  }, [users]);

  const datatableContent = useMemo(() => {
    return users.map((user) => {
      let actions = [
        {
          label: "Modifier",
          link: `/users/${user.uid}`,
        },
        {
          label: "Supprimer",
          onClick: async () => {
            if (
              !window.confirm(
                "Voulez-vous vraiment supprimer cet utilisateur ?"
              )
            )
              return;
            await deleteUsers(userInfos.jwt, [user.uid]);
            window.location.reload();
          },
        },
      ];

      return (
        <StyledTr
          key={user.uid}
          className={checked.includes(user.uid) ? "checked" : ""}
        >
          <td style={{ textAlign: "center" }}>
            <input
              type="checkbox"
              checked={checked.includes(user.uid)}
              name="bulk_action"
              value={user.uid}
              onChange={handleCheckbox}
            />
          </td>
          <td>{user.email}</td>
          <td>
            {moment(user.creationTime)
              .tz("Europe/Paris")
              .format("DD/MM/YYYY HH:mm")}
          </td>
          <td>
            {moment(user.lastSignInTime)
              .tz("Europe/Paris")
              .format("DD/MM/YYYY HH:mm")}
          </td>
          <td>
            <ActionsMenu items={actions} />
          </td>
        </StyledTr>
      );
    });
  }, [checked, users, userInfos.jwt]);

  function handleCheckbox(e) {
    const { value, checked: isChecked } = e.target;

    if (isChecked) {
      setChecked((old) => [...old, value]);
    } else {
      setChecked((old) => old.filter((id) => id !== value));
    }
  }

  const handleDeleteUser = useCallback(async () => {
    if (!window.confirm("Voulez-vous vraiment supprimer ces utilisateurs ?"))
      return;
    await deleteUsers(userInfos.jwt, checked);
    window.location.reload();
  }, [checked, userInfos]);

  const PortletFooter = useMemo(() => {
    if (checked.length > 0) {
      let actions = [
        {
          label: <TrashIcon />,
          onClick: handleDeleteUser,
        },
      ];

      return (
        <SelectionActionsPopup
          items={[]}
          selectedItemsLength={checked.length}
          resetChecked={() => setChecked([])}
          buttons={actions}
        />
      );
    }
  }, [checked.length, handleDeleteUser]);
  if (!loaded) {
    return (
      <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
        <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
          <div className="">
            <div className="kt-portlet__body">
              <div className="text-center">Chargement...</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="body-container">
      <div className="title-container">
        <h3 className="title">Utilisateurs</h3>
        <div className="header-toolbar">
          <OutlineButtonLink to="/add-user">
            <i className="la la-plus" />
            Créer un utilisateur
          </OutlineButtonLink>
        </div>
      </div>

      <div>
        <div className="">
          <div className="kt-portlet__body">
            <div style={{ overflowX: "auto" }}>
              <table
                className="table table-striped- table-bordered table-hover table-checkable"
                id="datatable"
              >
                <thead>
                  <tr>
                    <th
                      style={{ width: "2%", textAlign: "center" }}
                      data-sort="false"
                    >
                      Selection
                    </th>
                    <th style={{ width: "15%" }}>Email</th>
                    <th style={{ width: "8%" }}>Création</th>
                    <th style={{ width: "8%" }}>Dernière connexion</th>
                    <th style={{ width: "2%" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>{datatableContent}</tbody>
              </table>
            </div>
          </div>
          {PortletFooter}
        </div>
      </div>
    </div>
  );
}
